import React, { Component } from 'react';
import lodashFilter from 'lodash/filter';
import lodashForEach from 'lodash/forEach';
import lodashMap from 'lodash/map';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';
import { Data, Toolbar } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';
import { Button, ButtonToolbar, Row, Col } from 'react-bootstrap';
import { RowRenderer } from '../../Common/rowRenderer';
import { ROOT_URL, ROOT_API_URL, companyCodeTitle } from '../../../actions/root_url';

const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/";

const propTypes = {
};

const defaultProps = {
};

class SkusTableModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      filters: null,
      sortColumn: null,
      sortDirection: null,
    };
  }

  componentDidMount() {
    this.setState({
      rows: JSON.parse(this.props.skus)
    })
  }

  addSKU = () => {
    const newRow = {
      name: '',
      sku: '',
    }
    this.setState({
      rows: [...this.state.rows, newRow]
    })
  }

  saveSKU = () => {
    var str = JSON.stringify(this.state.rows);
    this.props.updateSKU(str);
  };

  renderExcel() {
    let { Product_id} = this.props;
    let disabled = false;
    if (!Product_id) {
      disabled = true;
    }
    const exportUrl = `${ROOT_URL}v1/product/sku_export/${this.props.Product_id}?Bearer=${localStorage.getItem("token")}`;

    return (
      <Button
        bsStyle="success"
        type="button"
        href={exportUrl}
        disabled={disabled}
      >
        <em className="fa fa-download" />
        <Translate value="excel" />
      </Button>
    );
  }

  render() {
    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const onClearFilters = () => {
      this.setState({ filters: {} });
    };

    const handleRowUpdated = (row) => {
      var newRow = this.state.rows;
      newRow[row.rowIdx] = {
        ...newRow[row.rowIdx],
        ...row.updated,
      }
      this.setState({
        rows: newRow,
      })
    };

    const columns = [
      {
        key: 'name',
        name: <Translate value="name" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: 'sku',
        name: <Translate value="sku" />,
        resizable: true,
        editable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
    ];

    return (
      <Row>
        <Col sm={12}>
          <ButtonToolbar>
            <Button
              type="button"
              bsStyle="primary"
              onClick={this.addSKU}
            >
              <em className="fa fa-plus" /><Translate value="add" />
            </Button>
            <Button
              type="button"
              bsStyle="primary"
              onClick={this.saveSKU}
            >
              <em className="fa fa-save" /><Translate value="save" />
            </Button>
            {isJML && this.renderExcel()}
          </ButtonToolbar>
          <div style={{ maxWidth: '100%', marginTop: '5px' }} id="linkProductsModal-dataGrid1">
            <ReactDataGrid
              rowKey="skus_table"
              enableCellSelect
              onRowUpdated={handleRowUpdated}
              rowHeight={25}
              minHeight={250}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
            />
          </div>
        </Col>
      </Row>
    );
  }
}

SkusTableModal.propTypes = propTypes;
SkusTableModal.defaultProps = defaultProps;

export default SkusTableModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Products/components/SkusModal.jsx